import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Link } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";
import Layout from "../../../components/common/nav/admin/nav.component";
import { reactLocalStorage } from "reactjs-localstorage";
import AWS from "aws-sdk";
import { useAuthenticator } from "@aws-amplify/ui-react";
import awsmobile from "../../../aws-exports";
import { GetValueFromArray } from "../../../helper/commonfunctions";
import { toast } from "react-toastify";
import moment from "moment";
import { Auth, Storage } from "aws-amplify";
import OnlyText from "../../../components/common/OnlyText";
import capitalizeFirst from "../../../components/common/capitalizeFirst";
import { Avatar } from 'primereact/avatar';


export default function AdminProfile() {
    const [value, setValue] = useState('');
    const [value2, setValue2] = useState(58151);
    const [date, setDate] = useState(null);
    const [localPicturePath, setLocalPicturePath] = useState('');
    const [previousLogin, setPreviousLogin] = useState(null);
    const [profilePic, setProfilePic] = useState('');



    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);

    //Get Current User
    const { user } = useAuthenticator((context) => [context.user]);


    const AWS = require('aws-sdk');

    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });


    const userId = reactLocalStorage.get("loggedUserId");
    const cognito = new AWS.CognitoIdentityServiceProvider();

    let userDetailsArray = [];
    userDetailsArray['FirstName'] = ''
    userDetailsArray['LastName'] = ''
    userDetailsArray['ProfilePic'] = ''
    userDetailsArray['sub'] = ''

    var params =
    {
        UserPoolId: awsmobile.aws_user_pools_id,
        Limit: 60
    };

    params['Filter'] = "sub ^=\"" + userId + "\""
    cognito.listUsers(params, (err, data) => {
        if (err) {
            toast.error(err.message);
        } else {
            userDetailsArray['FirstName'] = GetValueFromArray(data.Users[0].Attributes, "custom:firstName")
            userDetailsArray['LastName'] = GetValueFromArray(data.Users[0].Attributes, "custom:lastName")
            userDetailsArray['ProfilePic'] = GetValueFromArray(data.Users[0].Attributes, "custom:profileImage")
            userDetailsArray['sub'] = GetValueFromArray(data.Users[0].Attributes, "sub")
            console.log("userDetailsArray", userDetailsArray)
        }
    });



    //*select profile picture
    const browseProfilePic = () => {
        document.getElementById('fileProfilePic').click()
    }


    async function changeProfilePicture(e) {

        const file = e.target.files[0];
        const fileName = 'profile/' + reactLocalStorage.get("loggedUserId") + '/signature.jpeg';

        console.log("fileName", file);

        try {
            toast.loading('Uploading please wait...');
            await Storage.put(fileName, file, {
                resumable: true,
                completeCallback: (event) => {
                    toast.dismiss();
                    Auth.currentAuthenticatedUser()
                        .then((user) => {
                            return Auth.updateUserAttributes(user, {
                                'custom:profileImage': fileName,
                            });
                        })
                        .then((data) =>
                            toast.success('Profile picture updated successfully.')
                        )
                        .catch((err) => toast.error(err.message));
                },
                errorCallback: (err) => {
                    toast.error(err.message);
                },

            });
        } catch (error) {
            console.log('Error uploading file: ', error);
        }
    }




    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [employeeId, setEmployeeId] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [profilePicPath, setProfilePicPath] = useState("");


    const [bio, setBio] = useState("");
    const [website, setWebsite] = useState("");
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);

    console.log("profilePicPath", profilePicPath)



    useEffect(() => {

        const storedLogin = localStorage.getItem('previousLogin');
        if (storedLogin) {
            setPreviousLogin(storedLogin);
        }

        // onLoad()
        if (user) {
            const { attributes } = user;
            console.log("user", user)

            setEmail(attributes['email'])
            if (attributes['custom:firstName'] != null) {
                setFirstName(attributes['custom:firstName'])
            }
            if (attributes['custom:lastName'] != null) {
                setLastName(attributes['custom:lastName'])
            }
            if (attributes['custom:address'] != null) {
                setAddress(attributes['custom:address'])
            }

            if (attributes['custom:countryId'] != null) {
                setCountry(attributes['custom:countryId'])
            }
            if (attributes['custom:stateId'] != null) {
                setState(attributes['custom:stateId'])
            }
            if (attributes['custom:mobileNumber'] != null) {
                setPhone(attributes['custom:mobileNumber'])
            }
            if (attributes['custom:userCode'] != null) {
                setEmployeeId(attributes['custom:userCode'])
            }
            if (attributes['website'] != null) {
                setWebsite(attributes['website'])
            }
            if (attributes['custom:dateOfBirth'] != null) {
                setDate(attributes['custom:dateOfBirth'])
            }
            if (attributes['custom:profileImage'] != null) {
                setLocalPicturePath(attributes['custom:profileImage'])
            }
            if (attributes['custom:bio'] != null) {
                setBio(attributes['custom:bio'])
            }
            if (attributes['custom:profileImage'] != null) {

                Storage.get(attributes['custom:profileImage'])
                    .then(result => {
                        setProfilePicPath(result);
                    });
            }
        } else {
            const userId = reactLocalStorage.get("loggedUserId");
            const cognito = new AWS.CognitoIdentityServiceProvider();
            let userDetailsArray = [];
            userDetailsArray['FirstName'] = ''
            userDetailsArray['LastName'] = ''
            userDetailsArray['custom:profileImage'] = ''
            userDetailsArray['sub'] = ''
            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60
            };

            params['Filter'] = "sub ^=\"" + userId + "\""

            cognito.listUsers(params, (err, data) => {
                if (err) {
                    toast.error(err.message);
                } else {
                    setEmail(GetValueFromArray(data.Users[0].Attributes, "email"))
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:firstName") != null) {
                        setFirstName(GetValueFromArray(data.Users[0].Attributes, "custom:firstName"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:lastName") != null) {
                        setLastName(GetValueFromArray(data.Users[0].Attributes, "custom:lastName"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:address") != null) {
                        setAddress(GetValueFromArray(data.Users[0].Attributes, "custom:address"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:city") != null) {
                        setCity(GetValueFromArray(data.Users[0].Attributes, "custom:city"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:countryId") != null) {
                        setCountry(GetValueFromArray(data.Users[0].Attributes, "custom:countryId"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:stateId") != null) {
                        setState(GetValueFromArray(data.Users[0].Attributes, "custom:stateId"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:mobileNumber") != null) {
                        setPhone(GetValueFromArray(data.Users[0].Attributes, "custom:mobileNumber"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "website") != null) {
                        setWebsite(GetValueFromArray(data.Users[0].Attributes, "website"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:userCode") != null) {
                        setEmployeeId(GetValueFromArray(data.Users[0].Attributes, "custom:userCode"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:dateOfBirth") != null) {
                        setDate(GetValueFromArray(data.Users[0].Attributes, "custom:dateOfBirth"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:bio") != null) {
                        setBio(GetValueFromArray(data.Users[0].Attributes, "custom:bio"))
                    }
                    if (GetValueFromArray(data.Users[0].Attributes, "custom:profileImage") != null) {

                        setLocalPicturePath(GetValueFromArray(data.Users[0].Attributes, "custom:profileImage"))

                    }
                }
            });

        }

    }, [user]);

    async function updateProfile(event) {
        // event.preventDefault();
        if (firstName === "" || firstName === null) {
            toast.error('Enter first name')
        } else if (lastName === "" || lastName === null) {
            toast.error('Enter last name')
        }
        else if (!OnlyText(firstName)) { toast.error('Enter only alphabets to firstname.'); return; }
        else if (!OnlyText(lastName)) { toast.error('Enter only alphabets to lastname.'); return; }
        else {
            setPleaseWaitButton(true);
            Auth.currentAuthenticatedUser()
                .then(user => {
                    return Auth.updateUserAttributes(user,
                        {
                            'custom:firstName': capitalizeFirst(firstName),
                            'custom:lastName': capitalizeFirst(lastName),
                            "custom:userCode": employeeId,
                            "custom:dateOfBirth": date,
                            "custom:address": address,
                            "custom:countryId": capitalizeFirst(country),
                            "custom:stateId": state,
                            "custom:mobileNumber": phone,
                            "website": website,
                            "custom:bio": bio,

                        });
                })
                .then(data => { setPleaseWaitButton(false); toast.success('Profile updated successfully.') })
                .catch(err => { setPleaseWaitButton(false); toast.error(err.message) });
        }
    }





    return (
        <>
            <Layout pageTitle="Admin Profile">
                <div className="pt-10 px-4 md:px-10">
                    <div className="bg-white shadow-[0px_10.299px_13.732px_-3.43299px_rgba(16,24,40,0.1)] p-5">
                        <div className="text-[#344054] font-medium text-xl">Personal Information</div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 py-2">
                            <div className="px-2">
                                <div className="flex justify-start viewProfileAvatar gap-4">
                                    <Avatar
                                        image={profilePicPath ? profilePicPath : require('../../../assets/images/defaultProfile.jpg')}
                                        className="mr-2" size="xlarge" shape="circle" />
                                    <div>
                                        <div className="text-[#818C95] text-sm font-medium">Your Profile Picture</div>
                                        <div className="text-[#818C95] text-xs font-normal">Previous Login: {previousLogin}</div>
                                        <Link to='#' className=" my-2 bg-white border border-[#2D5BE5] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#2D5BE5] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center" onClick={browseProfilePic}><i className="pi pi-camera pr-2"></i><span>Change</span></Link>
                                        <input hidden id="fileProfilePic" type="file" onChange={changeProfilePicture} />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="mb-1 mt-2">
                                        <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">First Name</label>
                                        <div className="mt-1"><InputText
                                            value={(firstName)} onChange={e => setFirstName(e.target.value)}
                                            id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                                    </div>
                                    <div className="mb-1 mt-2">
                                        <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Last Name</label>
                                        <div className="mt-1"><InputText
                                            value={(lastName)} onChange={e => setLastName(e.target.value)}
                                            id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                                    </div>
                                </div>
                                <div className="mb-1 mt-2">
                                    <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Bio</label>
                                    <div className="mt-1"><InputTextarea
                                        value={bio}
                                        onChange={(e) => setBio(e.target.value)}
                                        className="w-full placeholder:text-[#667085]" placeholder="Bio" rows={3} cols={30} /></div>

                                </div>
                                <div className="mb-1 mt-2">
                                    <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Employee ID</label>
                                    <div className="mt-1"><InputText
                                        value={(employeeId)}
                                        onChange={e => setEmployeeId(e.target.value)}
                                        id="username" placeholder="ID123" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                                </div>
                                <div className="mb-1 mt-2">
                                    <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Date of Birth</label>
                                    <div className="mt-1">

                                        <InputText type={"date"} value={date}
                                            max={new Date().toISOString().split('T')[0]}
                                            onChange={(e) => {
                                                setDate(e.target.value)
                                            }} placeholder="MM-DD-YYYY" className="w-full placeholder:text-[#667085]" />
                                    </div>



                                </div>
                                <div className="mb-1 mt-2">
                                    <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Email</label>
                                    <div className="mt-1">
                                        <InputText
                                            value={email}
                                            readOnly={true}
                                            id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                                </div>
                            </div>

                            <div className="px-2 mt-[5.8vw]">
                                <div className="mb-1 mt-2">
                                    <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Phone Number</label>
                                    <div className="mt-1">
                                        <InputText
                                            type="number"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" />

                                    </div>
                                </div>

                                <div className="mb-1 mt-2">
                                    <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Address</label>
                                    <div className="mt-1"><InputTextarea
                                        defaultValue={(address)}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="w-full placeholder:text-[#667085]" placeholder="Address" rows={3} cols={30} /></div>

                                </div>
                                <div className="mb-1 mt-2">
                                    <label className="text-[#344054] text-sm md:text-[0.833vw] font-medium pb-2" htmlFor="username">Website</label>
                                    <div className="mt-1"><InputText
                                        value={website}
                                        onChange={(e) => setWebsite(e.target.value)}
                                        id="" placeholder="test.com" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>

                                </div>

                            </div>
                        </div>
                        <div className="flex justify-end items-center gap-2">
                            <Link to='/dashboard' className="w-20 text-center flex items-center tableBtn border border-[#D0D5DD] radius8">Cancel</Link>
                            <Link to='#'
                                type="submit"
                                onClick={() => updateProfile()}
                                className="bg-[#113699] text-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center w-20">Save</Link>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}